module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-contests",
    style: ({
      backgroundImage: "url(" + _vm.content.contests.bg + ")"
    })
  }, [_c('div', {
    staticClass: "home-contests__header"
  }, [_c('div', {
    staticClass: "home-contests__header-col home-contests__header-left"
  }, [_vm._v(_vm._s(_vm.content.contests.text))]), _c('div', {
    staticClass: "home-contests__header-col home-contests__header-right"
  }, [_vm._v(_vm._s(_vm.content.contests.title))])]), _c('div', {
    directives: [{
      name: "contests-slider-directive",
      rawName: "v-contests-slider-directive"
    }],
    staticClass: "home-contests__slider"
  }, _vm._l((_vm.content.contests.slider), function(slide) {
    return _c('div', {
      staticClass: "home-contests__slide"
    }, [_c('div', {
      staticClass: "home-contests__image",
      style: ({
        backgroundImage: 'url(' + slide.flyer + ')'
      })
    })])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79c07f6a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-contests/custom-home-contests.pug
// module id = 647
// module chunks = 1